import React from 'react';
import SkeletonLoader from '../../../components/ui/SkeletonLoader';

const EditorSkeleton = () => {
  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar skeleton */}
      <div className="hidden lg:block w-[280px] border-r border-border bg-card p-4">
        <SkeletonLoader variant="title" className="mb-6" />
        <div className="space-y-3">
          {[1, 2, 3, 4, 5]?.map((i) => (
            <SkeletonLoader key={i} variant="default" className="h-10" />
          ))}
        </div>
      </div>
      {/* Main content skeleton */}
      <div className="flex-1 flex overflow-hidden lg:ml-[280px]">
        {/* Left panel - thumbnails */}
        <div className="w-48 border-r border-border bg-card p-3 space-y-3">
          {[1, 2, 3, 4]?.map((i) => (
            <SkeletonLoader key={i} variant="page" className="h-32" />
          ))}
        </div>

        {/* Center - canvas */}
        <div className="flex-1 flex flex-col">
          {/* Toolbar */}
          <div className="border-b border-border bg-card p-4">
            <div className="flex items-center justify-between">
              <SkeletonLoader variant="button" className="w-32" />
              <SkeletonLoader variant="button" className="w-48" />
              <SkeletonLoader variant="button" className="w-32" />
            </div>
          </div>
          {/* Canvas area */}
          <div className="flex-1 flex items-center justify-center bg-muted/30 p-8">
            <SkeletonLoader className="w-full max-w-4xl aspect-[3/4]" />
          </div>
        </div>

        {/* Right panel - hotspot config */}
        <div className="w-80 border-l border-border bg-card p-4">
          <SkeletonLoader variant="title" className="mb-4" />
          <div className="space-y-4">
            {[1, 2, 3, 4, 5]?.map((i) => (
              <div key={i}>
                <SkeletonLoader variant="text" className="w-20 mb-2" />
                <SkeletonLoader variant="default" className="h-10" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorSkeleton;